import { announceLogout } from './sessionBus';
import { ACTIVE_SUB_KEY, LAST_BROADCAST_KEY, STALE_KEY, LOGOUT_KEY, ACCESS_TOKEN } from '../components/shared/constants';

export const jwtPayload = (accessToken: string) => {
  if (!accessToken || !accessToken.length) {
    return {};
  }
  return JSON.parse(atob(accessToken.split('.')[1]));
};

export const logoutLocal = auth0 => {
  // Tell other tabs to clear app state + show logged-out overlay
  announceLogout();

  // Clear this tab’s app state
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(ACTIVE_SUB_KEY);
  sessionStorage.removeItem(LAST_BROADCAST_KEY);
  sessionStorage.removeItem(STALE_KEY);
  sessionStorage.removeItem(LOGOUT_KEY);

  auth0.logout({ returnTo: window.location.origin });
};
